import React, { useState } from 'react';

import css from './stickerLoader.module.sass';

type PropTypes = {
  src: string;
};

export const StickerLoader: React.FC<PropTypes> = ({ src }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div className={css.stickerImgBox}>
      <img
        src={src}
        alt="sticker"
        className={css.stickerImg}
        onLoad={handleImageLoad}
      />
      {!isLoaded && <div className={css.spinner} />}
    </div>
  );
};
